import { create } from "zustand";
import { loadDecryptedMessages, parseMessage } from "../db/Message";

const useConversationStore = create((set, get) => ({
  latestMessage: null,

  receiveMessage: async ({ 
    message,
    userId, 
    password,
    salt,
  }) => {
    // Sync update to UI (must be sync to trigger React updates)
    set(() => ({
      latestMessage: message,
    }));
  },

  reset: () => set({ latestMessage: null }),
}));

export default useConversationStore;